'use client'
import { tw } from '@/lib/utils'

import type { LauncherPanelProps } from './launcher-panel'
import styles from './launcher-styles'
import { LauncherTree } from './launcher-tree'

import { useNavContext } from '../nav-context-provider'
import { SheetCardGrid } from '../sheet/sheet-card-grid'
import { SheetSearchInput } from '../sheet/sheet-search-input'

// The category tree sits beside search, the two-column grid and its footer.
// Search stays pinned while the grid and footer scroll together.
export const LauncherSection = ({ container, query, inputRef, Results }: LauncherPanelProps) => {
  const navContext = useNavContext()
  const panels = container.panels ?? []
  const activePanel = panels.find((panel) => panel.id === navContext.current.panelId) ?? panels[0]
  const tabs = activePanel?.tabs ?? []
  const activeTab = tabs.find((tab) => tab.id === navContext.current.tabId) ?? tabs[0]
  const showResults = !!query.results
  const rowsKey = showResults ? 'results' : (activeTab?.id ?? activePanel?.id ?? container.id)
  const skeleton = activeTab ? activeTab.skeleton : activePanel?.skeleton

  return (
    <div className="flex min-h-0 flex-1 gap-x-6 laptop:gap-x-8 min-[1440px]:gap-x-10">
      {panels.length && !showResults ? (
        <LauncherTree
          key={container.id}
          panels={panels}
          activePanelId={activePanel?.id}
          activeTabId={activeTab?.id}
          onSelectPanel={(panel) => navContext.set({ panel })}
          onSelectTab={(tab) => navContext.set({ tab })}
        />
      ) : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <SheetSearchInput
          term={query.searchTerm}
          onChange={query.setSearchTerm}
          onClear={query.reset}
          searching={query.searching}
          autoFocus={false}
          inputRef={inputRef}
          className="pt-2 pb-4"
        />
        <div
          key={rowsKey}
          className={tw(
            '-mx-2 min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain px-2 pb-2',
            styles.rowsIn,
            styles.scroll
          )}
        >
          {Results ? (
            <Results container={container} query={query} />
          ) : (
            <SheetCardGrid items={[]} renderItem={() => null} loading={Math.min(skeleton?.count ?? 4, 6)} />
          )}
        </div>
      </div>
    </div>
  )
}
